// Thin wrapper over the youforgot tag loaded in public/index.html.
// The tag exposes window.yf(name, data) and already sends the current path with
// every event, so callers only pass what the path does not already say.
export function trackEvent(name, data) {
    if (typeof window !== 'undefined' && typeof window.yf === 'function') {
        window.yf(name, data || {});
    }
}

// Affiliate clicks are this site's revenue event.
//
// They live inside model-generated article HTML rendered via
// dangerouslySetInnerHTML, so there is no React element to hang an onClick on.
// One delegated listener on the document covers every affiliate link on the
// site - including the ~240 articles already published - with no content edits
// and nothing for the article generator to remember to emit.
//
// Matches rel="nofollow sponsored", which is what the generator writes for
// every affiliate link (see netlify/functions/utils/daily-core.js).
//
// Capture phase, mirroring the tag's own delegated listener, so the beacon is
// queued before the browser starts navigating away. The tag sends via
// navigator.sendBeacon, which is built to survive the unload.
export function initAffiliateClickTracking() {
    if (typeof document === 'undefined') return;

    document.addEventListener('click', (ev) => {
        const target = ev.target;
        if (!target || typeof target.closest !== 'function') return;

        const link = target.closest('a[rel~="sponsored"]');
        if (!link) return;

        let merchant = '';
        try {
            merchant = new URL(link.href, window.location.origin).hostname;
        } catch (e) {
            // A malformed href should never cost us the event.
        }

        trackEvent('affiliate-click', { href: link.href, merchant });
    }, true);
}
